import JsPDF from 'jspdf';
import 'jspdf-autotable';
import { LOGO_DESENVOLVA, LIGHT_THEME } from '@/modules/var';
import updateToken from '@/middlewares/updateToken-middleware';
import Store from '@/store';

import Data from '@/modules/data';

let pdf;
let orientacao;
const font = 'Helvetica';
const cores = {
  default: '#202020',
  grey: '#DCDCDC',
  black: '#000000',
  white: '#FFFFFF',
  link: '#0044CC',
  ...LIGHT_THEME,
};
let x = 15;
let y = 10;
/*
########################################################################################################################
# Estrutura padrão a ser recebida no (generatePDF) para gerar relatórios
# Obrigatório [cabecalho, blocos]
const documento = {
  nome: 'nome do arquivo',
  cabecalho: {
    titulo: 'TÍTULO',
    subtitulo: 'Subtítulo',
    itens: ['texto cabeçalho 1', 'texto cabeçalho 2'],
  },
  blocos: [
    # Bloco do tipo texto
    {
      titulo: 'TÍTULO',
      subtitulo: 'Subtítulo',
      itens: [
        {tipo: 'texto', valor: 'texto'},
        {tipo: 'texto', valor: 'parágrafo'},
      ],
    },
    # Bloco do tipo imagem
    # A imagem pode ser obtida importando o método getCanvas ou pode ser informada em Base64
    # Para usar o método getCanvas é necessário informa o id do elemento da página a ser capturado
    {
      titulo: 'GRÁFICOS',
      subtitulo: 'Gráficos',
      itens: [{tipo: 'imagem', valor: await getCanvas('#id'), largura: valor, altura: valor}],
    },
    # Bloco do tipo tabela
    {
      titulo: 'RESULTADOS',
      subtitulo: 'Resultados',
      itens: [{
        tipo: 'tabela',
        valor: {
          # A propriedade (simples) com valor true remove a ordenação e a numeração das linhas
          simples: true
          colunas: ['Coluna A', 'Coluna B', 'Coluna C'],
          linhas: [
            ['1', '2', '3'],
            ['4', '5', '6'],
          ],
          rodape: ['5', '7', '9'],
          customizacoes = [
            {
              # Os possíveis valores para a propriedade (secao) são (head, body, foot)
              secao: 'body',
              # A propriedade (colunas) recebe as colunas que deverão ser customizadas
              colunas: [1],
              estilos: [
                {
                  # A propriedade (cor) pode receber todos os nomes de cores definidos aqui no módulo
                  cor: 'success',
                  # Os possíveis valores para a propriedade (formatcao) são (normal, bold, italic, bolditalic)
                  formatacao: 'bold',
                  tamanho: 12,
                  # A propriedade (valores) recebe valores para comparação e customização da coluna
                  valores: this.indicacoesTalento.map((i) => i.competencia.nome),
                },
                {
                  cor: 'error',
                  formatacao: 'bold',
                  tamanho: 12,
                  valores: this.indicacoesDesenvolvimento.map((i) => i.competencia.nome),
                },
              ],
            },
            {
              secao: 'foot',
              colunas: [1],
              estilos: [
                {
                  cor: 'secondary',
                  # Formatação do texto (Possibilidades: 'normal', 'bold', 'italic', 'bolditalic')
                  formatacao: 'bold',
                  tamanho: 12,
                  valores: ['TOTAL'],
                },
              ],
            },
          ],
        },
      }],
    },
    # O rodapé pode ser informado, mas não é necessário porque já é inserido conforme o formato pré-definido
    rodape: 'Rodapé',
  ],
};
########################################################################################################################
*/

function addPagina() {
  pdf.addPage();
}

function checkTamanhoPagina(tamanho) {
  if (orientacao === 'landscape') {
    if (tamanho > 200) {
      addPagina();
      y = 15;
    }
  } else if (tamanho > 280) {
    addPagina();
    y = 15;
  }
}

function addTitulo(titulo, cor = 'primary') {
  checkTamanhoPagina(y + 15);
  pdf.setFont(font, 'bold');
  pdf.setFontSize(12);
  pdf.setTextColor(cores[cor]);
  pdf.text(titulo.toUpperCase(), x, y);
  y += 5;
}

function addSubtitulo(subtitulo, cor = 'default') {
  checkTamanhoPagina(y + 15);
  pdf.setFont(font, 'bold');
  pdf.setFontSize(11);
  pdf.setTextColor(cores[cor]);
  pdf.text(subtitulo, x, y);
  y += 5;
}

function addTexto(texto, cor = 'default', tamanhoLinha = 200) {
  const textoAjustado = pdf.splitTextToSize(texto, tamanhoLinha);
  checkTamanhoPagina(y + (textoAjustado.length * 4) + 5);
  pdf.setFont(font, 'normal');
  pdf.setFontSize(10);
  pdf.setTextColor(cores[cor]);
  pdf.text(textoAjustado, x, y);
  y += (textoAjustado.length * 4);
}

function addLink({
  texto = window.location.origin,
  url = window.location.origin,
  inicio = x,
  altura = y,
}) {
  pdf.setTextColor(cores.link);
  pdf.textWithLink(
    texto,
    inicio,
    altura,
    { url },
  );
}

function addImagem(imagem, largura = 200, altura = 80) {
  checkTamanhoPagina(y + altura + 5);
  const larguraPagina = pdf.internal.pageSize.getWidth();
  const xImagem = (larguraPagina - largura) / 2;
  pdf.addImage(imagem, 'JPEG', xImagem, y, largura, altura);
  y += altura + 5;
}

function addTabela(tabela) {
  // Largura da tabela (recebe a largura ou undefined)
  const tableWidth = tabela.largura;

  if (!tabela.simples) {
    // Ordenação e numeração das linhas
    tabela.colunas.unshift('');
    if (tabela.linhas.length > 0 && typeof tabela.linhas[0][0] === 'string') {
      tabela.linhas.sort((a, b) => a[0].localeCompare(b[0]));
    }
    if (tabela.linhas.length > 0 && typeof tabela.linhas[0][0] === 'number') {
      tabela.linhas.sort((a, b) => {
        if (a[0] > b[0]) {
          return 1;
        }
        if (b[0] > a[0]) {
          return -1;
        }
        return 0;
      });
    }
    tabela.linhas = tabela.linhas.map((linha, index) => [index += 1, ...linha]);
    if (tabela.rodape) {
      if (Array.isArray(tabela.rodape[0])) {
        tabela.rodape.forEach((linha) => linha.unshift(''));
      } else {
        tabela.rodape.unshift('');
      }
    }
  }

  // Customização de células
  let willDrawCell;
  if (tabela.customizacoes && tabela.customizacoes.length > 0) {
    willDrawCell = (data) => {
      const secao = data.section;
      const coluna = data.column.index + (tabela.simples ? 1 : 0);
      const valor = data.cell.raw;
      const customizacao = tabela.customizacoes.find((c) => c.secao === secao);
      if (customizacao && customizacao.colunas.some((c) => c === coluna)) {
        const estilo = customizacao.estilos.find((e) => e.valores.some((v) => v === valor));
        if (estilo) {
          if (estilo.cor) {
            pdf.setTextColor(cores[estilo.cor]);
          }
          if (estilo.formatacao) {
            pdf.setFont(font, estilo.formatacao);
          }
          if (estilo.tamanho) {
            pdf.setFontSize(estilo.tamanho);
          }
        }
      } else {
        pdf.setTextColor(cores.default);
        pdf.setFont(font, 'normal');
        pdf.setFontSize(10);
      }
    };
  }

  // Montagem da Tabela
  pdf.autoTable({
    tableWidth,
    startY: y,
    margin: { left: x },
    theme: 'grid',
    headStyles: {
      fillColor: cores.white,
      textColor: cores.default,
      lineWidth: 0.1,
      halign: 'center',
      valign: 'middle',
    },
    footStyles: {
      fillColor: cores.grey,
      textColor: [0, 0, 0],
      halign: 'center',
      valign: 'middle',
    },
    bodyStyles: { halign: 'center', valign: 'middle' },
    head: [tabela.colunas],
    body: [...tabela.linhas],
    foot: tabela.rodape ? (Array.isArray(tabela.rodape[0]) ? [...tabela.rodape] : [tabela.rodape]) : undefined,
    willDrawCell,
  });
  y = pdf.autoTable.previous.finalY;
}

function addRodape(rodape = null, cor = 'default') {
  const altura = orientacao === 'landscape' ? 200 : 287;
  const inicio = 15;
  const centro = pdf.internal.pageSize.width / 2;
  const fim = pdf.internal.pageSize.width - 55;
  const numeroPaginas = pdf.internal.getNumberOfPages();
  if (!rodape) {
    rodape = `Emitido em ${Data.get('LL')}`;
  }

  for (let i = 1; i <= numeroPaginas; i += 1) {
    pdf.setPage(i);
    pdf.setFont(font, 'italic');
    pdf.setFontSize(8);
    addLink({
      texto: `Sistema Desenvolva, ${window.location.origin}`,
      url: window.location.origin,
      inicio,
      altura,
    });
    pdf.setTextColor(cores[cor]);
    pdf.text(`Página ${i} de ${numeroPaginas}`, centro, altura, {
      align: 'center',
    });
    pdf.text(rodape, fim, altura);
  }
}

function salvar(nome) {
  pdf.save(nome || 'relatorio');
}

async function getCanvas(referencia) {
  let canvas = null;
  const opcoes = {
    ignoreElements: (el) => (el.tagName.toLowerCase() === 'g'
    && el.getAttribute('class') === 'highcharts-exporting-group'),
  };
  await window.html2canvas(document.querySelector(referencia), opcoes).then((c) => canvas = c);
  return canvas;
}

async function preparePdf(f) {
  Store.dispatch('app/setLoading', true);
  setTimeout(async () => {
    await f();
    Store.dispatch('app/setLoading', false);
  }, '500');
}

async function convertSvg(svgString) {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  const image = new Image();
  const width = 900;
  const height = 400;
  canvas.width = width;
  canvas.height = height;

  if (svgString) {
    return new Promise((resolve, reject) => {
      const parser = new DOMParser();
      const svg = parser.parseFromString(svgString, 'text/html').body.getElementsByTagName('svg')[0];
      image.onload = () => {
        context.drawImage(image, 0, 0, width, height);
      };
      image.src = `data:image/svg+xml;base64, ${Buffer.from(svg.outerHTML, 'utf-8').toString('base64')}`;

      setTimeout(() => {
        if (context.canvas) {
          return resolve(context.canvas.toDataURL('image/jpg'));
        }
        reject();
      }, '500');
    });
  }
  return canvas.toDataURL('image/jpg');
}

function addCabecalho(cabecalho) {
  const largura = 24;
  const altura = 24;
  pdf.addImage(LOGO_DESENVOLVA, 'PNG', x, y, largura, altura);
  x += largura + 5;
  y += 5;
  addTitulo('SISTEMA DESENVOLVA (UFC)');
  addTitulo(cabecalho.titulo, 'secondary');
  if (cabecalho.subtitulo) {
    addSubtitulo(cabecalho.subtitulo);
  }
  cabecalho.itens.forEach((i) => {
    if (i && typeof i === 'string') {
      addTexto(i, 'default', (pdf.internal.pageSize.getWidth() - x - 10));
    }
  });
  if (cabecalho.itens.length < 4) {
    y = altura + 20;
  } else {
    y += 5;
  }
  x = 15;
}

function addBloco(bloco) {
  const largura = 180;
  y += 5;
  if (bloco.titulo) {
    addTitulo(bloco.titulo);
  }
  if (bloco.subtitulo) {
    addSubtitulo(bloco.subtitulo);
  }
  if (bloco.itens) {
    bloco.itens.forEach((i) => {
      switch (i.tipo) {
        case 'texto':
          y += 7;
          addTexto(i.valor);
          break;
        case 'imagem':
          addImagem(i.valor, i.largura ? i.largura : largura, i.altura ? i.altura : 80);
          break;
        case 'tabela':
          addTabela(i.valor);
          break;
        default:
          break;
      }
    });
  }
  y += 5;
}

function generatePDF(documento) {
  // Atualiza o token
  updateToken();

  if (documento.cabecalho && documento.blocos && documento.blocos.length > 0) {
    orientacao = documento.orientacao ? documento.orientacao : 'portrait';
    pdf = new JsPDF(orientacao);

    pdf.setProperties({
      title: documento.cabecalho.titulo || '',
      author: 'Sistema Desenvolva (UFC)',
      subject: 'Relatório de dados',
      creator: 'Desenvolva',
    });

    addCabecalho(documento.cabecalho);
    documento.blocos.forEach((b) => {
      addBloco(b);
    });
    addRodape(documento.rodape);
    salvar(`${documento.nome}-${Data.get('DDMMYYYY')}`);

    // Reinicializa as coordenadas
    x = 15;
    y = 10;
  } else {
    Store.dispatch('app/showMessage', {
      cor: 'error',
      texto: 'Erro! Não foi possível gerar o relatório com os dados informados.',
    });
  }
}

export {
  generatePDF,
  preparePdf,
  getCanvas,
  convertSvg,
};
